import React, { createContext, useContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

const BulkPlaybookUpdateModalContext = createContext({});

export function useBulkPlaybookUpdateModalContext() {
  return useContext(BulkPlaybookUpdateModalContext);
}

export default function BulkPlaybookUpdateModalContextProvider({ children }) {
  const [activeModal, setActiveModal] = useState(null);
  const [modalData, setModalData] = useState(null);

  const onOpenModal = useCallback((modalName, data = null) => {
    setActiveModal(modalName);
    setModalData(data);
  }, []);

  const onCloseModal = useCallback(() => {
    setActiveModal(null);
    setModalData(null);
  }, []);

  return (
    <BulkPlaybookUpdateModalContext.Provider
      value={{
        activeModal,
        modalData,
        onOpenModal,
        onCloseModal,
        ...modalData,
      }}
    >
      {children}
    </BulkPlaybookUpdateModalContext.Provider>
  );
}

BulkPlaybookUpdateModalContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
